export default __webpack_public_path__ + "static/media/Answers.66ed9b80.svg";